import React from "react";
import { useSelector } from "react-redux";
import { selectTheme } from "../../../Store/features/design/designSlice";
import "./SkeletonLoader.scss";

const SkeletonLoader = ({ type = "text", count = 1, width, height }) => {
	const theme = useSelector(selectTheme);

	const renderSkeleton = () => {
		let skeletons = [];

		for (let i = 0; i < count; i++) {
			skeletons.push(
				<div
					key={i}
					className={`skeleton skeleton-${type} ${theme}`}
					style={{
						width: width || "",
						height: height || "",
					}}
				/>
			);
		}

		return skeletons;
	};

	return <div className={`skeleton-wrapper ${theme}`}>{renderSkeleton()}</div>;
};

export default SkeletonLoader;
